export var EventType;
(function (EventType) {
    EventType[EventType["NA_EVENT_TYPE"] = 0] = "NA_EVENT_TYPE";
    EventType[EventType["RSVP"] = 1] = "RSVP";
    EventType[EventType["TICKETS"] = 2] = "TICKETS";
    EventType[EventType["EXTERNAL"] = 3] = "EXTERNAL";
    EventType[EventType["NO_REGISTRATION"] = 4] = "NO_REGISTRATION";
    EventType[EventType["RSVP_AND_TICKETS"] = 5] = "RSVP_AND_TICKETS";
})(EventType || (EventType = {}));
